import { z } from "zod";

// Parent starts (or continues) a thread about their child with a team's coaches.
export const startConversationSchema = z.object({
  player_id: z.string().min(1, "Player is required"),
  team_id: z.string().min(1, "Team is required"),
  body: z.string().trim().min(1, "Message cannot be empty").max(4000, "Message too long"),
  subject: z.string().trim().max(140, "Subject too long").optional(),
});

export const sendConversationMessageSchema = z.object({
  body: z.string().trim().min(1, "Message cannot be empty").max(4000, "Message too long"),
});

export type StartConversationInput = z.infer<typeof startConversationSchema>;
export type SendConversationMessageInput = z.infer<typeof sendConversationMessageSchema>;
